import React from 'react';

type ButtonClickProps = Pick<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  'onClick'
>;

const AddColumn = ({ onClick }: ButtonClickProps) => (
  <button type="button" onClick={onClick} className="add-column">
    +
  </button>
);

const AddRow = ({ onClick }: ButtonClickProps) => (
  <button type="button" onClick={onClick} className="add-row">
    +
  </button>
);

const SelectColumn = ({ onClick }: ButtonClickProps) => (
  <button type="button" onClick={onClick} className="select-column" />
);

const SelectRow = ({ onClick }: ButtonClickProps) => (
  <button type="button" onClick={onClick} className="select-row" />
);

const SelectTable = ({ onClick }: ButtonClickProps) => (
  <button type="button" onClick={onClick} className="select-table" />
);

interface RowControlProps {
  onAdd: (offset: number) => void;
  onSelect: () => void;
}

export const RowControl = ({ onAdd, onSelect }: RowControlProps) => (
  <div className="row-controls">
    <AddRow onClick={() => onAdd(0)} />
    <SelectRow onClick={onSelect} />
    <AddRow onClick={() => onAdd(1)} />
  </div>
);

interface TableControlProps {
  insertColumn: (offset: number) => void;
  numColumns: number;
  selectColumn: (offset: number) => void;
  selectTable: () => void;
}

export const TableControl = ({
  insertColumn,
  numColumns,
  selectColumn,
  selectTable,
}: TableControlProps) => (
  <tr>
    <th>
      <SelectTable onClick={selectTable} />
    </th>
    {new Array(numColumns).fill(0).map((_n, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <th key={i}>
        <div className="column-controls">
          <AddColumn onClick={() => insertColumn(i)} />
          <SelectColumn onClick={() => selectColumn(i)} />
          <AddColumn onClick={() => insertColumn(i + 1)} />
        </div>
      </th>
    ))}
  </tr>
);
